module.exports = __webpack_public_path__ + "img/folder.3a9fe2a5.svg";